<script setup lang="ts">
import { useTagStore } from '~/stores/tag'

import type Tag from '~/entities/tag'
import type { Influencer } from '~/types/influencer'

type AvailableMarkType = 'free' | 'new'

type Props = {
  influencer: Influencer
}

const props = defineProps<Props>()

const { GET_TAGS_FROM_IDS } = useTagStore()

const availableMarks = ref<AvailableMarkType[]>(['free', 'new'])
const markTags = ref<Tag[]>([])

const type = computed<'free' | 'new' | undefined>(() => {
  for (const markName of availableMarks.value) {
    const tag = markTags.value.find((tag) => tag.name === markName)

    if (tag && tag.name === markName) return tag.name
  }
  return undefined
})

// runs during setup
markTags.value = computeMarkTags()

function computeMarkTags(): Tag[] {
  return GET_TAGS_FROM_IDS(
    props.influencer.tags?.identity.influencer_mark ?? [],
  )
}
</script>

<template>
  <div v-if="type" class="influencerTextBadge" :class="[type]">
    <span>{{ $t(`influencer.textBadge.${type}`) }}</span>
  </div>
</template>

<style scoped>
.influencerTextBadge {
  padding: 4px 8px;
  border-radius: 2px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.influencerTextBadge > span {
  text-transform: uppercase;
  color: var(--color-white);
  font-size: var(--font-size-eleven);
  font-weight: 600;
}

.influencerTextBadge.free {
  background-color: var(--color-cute);
}

.influencerTextBadge.new {
  background-color: var(--color-param);
}
</style>
